import { LinearProgress } from '@mui/material';

const ProgressBarV2: React.FC<{ percentage: number }> = ({ percentage }) => {
  return (
    <LinearProgress
      color="primary"
      variant="determinate"
      value={percentage}
      sx={(theme) => ({
        height: '10px',
        [theme.breakpoints.up('sm')]: {
          boxShadow: 'inset 0px 4px 4px -4px',
        },
        [theme.breakpoints.down('sm')]: {
          top: '18px',
          borderTop: `solid 1px ${theme.palette.neutral.lighter}`,
          height: '11px',
          width: '100vw',
        },
      })}
    />
  );
};
export default ProgressBarV2;
